/* src/app/modules/print-cards/components/cards/backgrounds/address-cards-1x3/harlequin-address-card-stack-background/harlequin-address-card-stack-background.component.scss */
:host {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
  box-sizing: border-box;
}
:host .main-content {
  flex: 1;
}
:host .main-content .print-card-background-asset {
  height: 100%;
  width: 100%;
}
/*# sourceMappingURL=harlequin-address-card-stack-background.component.css.map */
